import { inject } from '@angular/core';

import { WritableStateSource } from '@ngrx/signals';

import { AUTH_ADAPTER } from '../auth-adapter.token';
import { AuthState } from './auth.state';

export const authAdapterMethodsFactory = (store: WritableStateSource<AuthState>, authAdapter = inject(AUTH_ADAPTER)) => ({
  async createUser(email: string, password: string, fullName: string, marketingConsent: boolean): Promise<void> {
    await authAdapter.createUser(email, password, fullName, marketingConsent);
  },
  async signInWithEmailAndPassword(email: string, password: string): Promise<void> {
    await authAdapter.signInWithEmailAndPassword(email, password);
  },
  async signInWithFacebook(): Promise<void> {
    await authAdapter.signInWithFacebook();
  },
  async signInWithGoogle(marketingConsent: boolean): Promise<void> {
    await authAdapter.signInWithGoogle(marketingConsent);
  },
  refreshToken(): Promise<string | null> {
    return authAdapter.refreshToken();
  },
  signOut(): void {
    authAdapter.signOut();
  },
});
